const Paths = {
    bannerPlace: '/banners/banner-places',
};

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/BannerPlace/paths.ts